import { styled } from '@mui/system'
import React from 'react'
import { APIPriceRange } from 'services/api/entities/catalog/types'
import { useKArrayInput } from 'services/hooks/useKArrayInput'
import KNumberInput from 'ui-shared/WrappedInputs/KNumberInput'
import MarginPercAndVatFields from '../MarginPercAndVatFields'
import { limitToOneDecimal } from './StandardPricingInput'

const PREFIX = 'VariablePricesInput'

const classes = {
  container: `${PREFIX}-container`,
  numberInput: `${PREFIX}-numberInput`,
}

const StyledDiv = styled('div')({
  [`& .${classes.container}`]: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    width: '100%',
  },
  [`& .${classes.numberInput}`]: {
    width: '300px',
    marginRight: '24px',
  },
})

type Props = { source?: string; style?: React.CSSProperties }

const FixedPricesInput: React.FC<Props> = ({ source, style }) => {
  const { kGetSource } = useKArrayInput<APIPriceRange>(source)

  return (
    <StyledDiv style={style}>
      <div className={classes.container}>
        <KNumberInput
          source={kGetSource('fixedCost')}
          label="form.fields.fixedCost"
          className={classes.numberInput}
          parse={limitToOneDecimal}
        />
        <KNumberInput
          source={kGetSource('fixedPrice')}
          label="form.fields.fixedPrice"
          className={classes.numberInput}
          parse={limitToOneDecimal}
        />

        <MarginPercAndVatFields
          costSource={kGetSource('fixedCost')}
          priceSource={kGetSource('fixedPrice')}
        />
      </div>
    </StyledDiv>
  )
}

export default FixedPricesInput
